import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import ScheduleIcon from "@mui/icons-material/Schedule";
import { Box, Typography } from "@mui/material";
import { selectCurrentCompany } from "../../../../../redux/features/user/selectors/userState.selectors";
import { useAppSelector } from "../../../../../redux/hooks/redux";
import { formatDate } from "../../../../../utils";
import { colors } from "../../../../ui/colors";

interface Props {
  createdAt: string;
  startDate: string | null;
  endDate: string | null;
}

export const JobCardDates = ({ createdAt, startDate, endDate }: Props) => {
  const currentCompany = useAppSelector(selectCurrentCompany);

  return (
    <Box>
      <Box display="flex" alignItems="center" gap={1.5} mb={2}>
        <CalendarMonthIcon sx={{ color: colors.orange.base, fontSize: 20 }} />
        <Box>
          <Typography
            variant="caption"
            sx={{
              color: colors.gray[400],
              fontWeight: 700,
              textTransform: "uppercase",
              letterSpacing: "0.04em",
              fontSize: "0.6rem",
              display: "block",
            }}
          >
            Created
          </Typography>
          <Typography variant="body2" sx={{ fontWeight: 500, color: colors.gray[700], fontSize: "0.74rem", lineHeight: 1.35 }}>
            {formatDate(createdAt, currentCompany?.timeZone, "MMM dd, yyyy")}
          </Typography>
        </Box>
      </Box>

      {startDate && endDate && (
        <Box display="flex" alignItems="center" gap={1.5}>
          <ScheduleIcon sx={{ color: colors.orange.base, fontSize: 20 }} />
          <Box>
            <Typography
              variant="caption"
              sx={{
                color: colors.gray[400],
                fontWeight: 700,
                textTransform: "uppercase",
                letterSpacing: "0.04em",
                fontSize: "0.6rem",
                display: "block",
              }}
            >
              Schedule
            </Typography>
            <Typography variant="body2" sx={{ fontWeight: 500, color: colors.gray[700], fontSize: "0.74rem", lineHeight: 1.35 }}>
              {formatDate(startDate, currentCompany?.timeZone, "MMM dd, yyyy HH:mm")} –{" "}
              {formatDate(endDate, currentCompany?.timeZone, "MMM dd, yyyy HH:mm")}
              <span style={{ fontWeight: 500 }}> {currentCompany?.timeZone}</span>
            </Typography>
          </Box>
        </Box>
      )}
    </Box>
  );
};
